<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="2 1 24 24">
    <title>home</title>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.3335 21.1613C22.8858 21.1613 23.3335 20.7136 23.3335 20.1613V10.8914H23.3384V5.84394C23.3384 5.31927 22.913 4.89394 22.3884 4.89394H19.262C18.7373 4.89394 18.312 5.31927 18.312 5.84394V6.68769L14.6519 3.74992C14.2891 3.45875 13.7735 3.45617 13.4078 3.74369L4.66699 10.6167V20.1613C4.66699 20.7136 5.11471 21.1613 5.66699 21.1613H22.3335ZM21.8335 11.4376L14.0227 5.16836L6.16699 11.3454V19.6613H10.5273V11.2503H17.473V19.6613H21.8335V11.4376ZM19.812 7.89165L21.8384 9.51809V6.39394H19.812V7.89165ZM15.973 19.6613V12.7503H12.0273V19.6613H15.973Z"
    />
  </svg>
</template>
